import {
  Component,
  Input,
  OnDestroy,
  OnInit
} from "@angular/core";
import { Router } from "@angular/router";
import { ProFunnelModel } from "../../../../model/builk/profunnel/profunnel.model";
import { ProFunnelService } from "../../../../service/api/builk/profunnel.service";
import { ISubscription } from "rxjs/Subscription";

@Component({
  selector: "bo-builk-profunnel-comment",
  templateUrl: "./profunnel-comment.component.html",
  styleUrls: ["./profunnel-comment.component.scss"]
})
export class ProFunnelCommentComponent implements OnInit, OnDestroy {

  @Input() rowData: ProFunnelModel;

  constructor(
    public router: Router,
    public proFunnelService: ProFunnelService
  ) {
  }

  proFunnel: ProFunnelModel = new ProFunnelModel();
  subscription: ISubscription;

  ngOnInit(): void {
  }

  // update Comment by id
  updateComment(id: number, comment: string): void {
    this.proFunnel.comment = comment;
    this.proFunnel.id = id;
    this.subscription = this.proFunnelService.updateCommentProFunnelBackOffice(this.proFunnel)
      .subscribe(
        Response => {
        },
        err => {
          // error
        }
      );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
